import i18n from '../lang/i18n';

/**
 * Convert the value of the from to a well indented block of text
 */
const convert = (formValues) => {
    
    let htmlBlob = "";
    htmlBlob += addLine(formValues, "date");
    htmlBlob += addLine(formValues, "buildingType");
    
    const buildingValues = formValues[formValues["buildingType"]]

    for(var key in buildingValues) {
        if (buildingValues.hasOwnProperty(key) && !key.includes("files")) {
            if(typeof buildingValues[key] !== 'object' && isElementVisible(key, formValues["buildingType"])) {
                htmlBlob += addLine(buildingValues, key);
            } else if (typeof buildingValues[key] === 'object' && !isEmptyObject(buildingValues[key])) {
                var context = formValues["buildingType"] + "." + key;
                htmlBlob += addObjectLine(buildingValues[key], context);
            }
        }
    }

    return htmlBlob;
}

/**
 * Verify if an element is visible
 * @param {*} elName The name of the element (ex: myname)
 * @param {*} context The context - or path - of the element (ex: root.subroot)
 * @returns Boolean
 */
function isElementVisible(elName, context) {
    var key = context + "." + elName;
    var elList = document.getElementsByName(key);

    if (elList !== null && elList.length === 1) {
        return (elList[0].offsetParent !== null);
    }
}

/**
 * An object is empty is it has:
 *  - no property of its own 
 *  - if its properties are not null or empty
 *  - it its properties contains default in their value string
 */
function isEmptyObject(o) {
    return Object.keys(o).every(function(x) {
        return !o.hasOwnProperty(x) || o[x]==='' || o[x]===null || o[x].toLowerCase().indexOf("default") >= 0;
    });
}

/**
 * Create text line for an object
 */
const addObjectLine = (item, context) => {
    var subObjectKey = "";
    var textToReturn = "";

    for(var key in item) {
        if (item.hasOwnProperty(key)) {
            subObjectKey = key;

            if(subObjectKey.toLowerCase().indexOf("specify") > 0 && isElementVisible(key, context)) {
                textToReturn += "    " + i18n.t(item[subObjectKey]) + "\n";
            }
            //If SubObject is an object
            else if(typeof item[subObjectKey] === 'object' && !isEmptyObject(item[subObjectKey])) {
                let subContext = context + "." + subObjectKey;
                textToReturn += addObjectLine(item[subObjectKey], subContext);
            }
            else if (isElementVisible(subObjectKey, context)) {
                textToReturn +=  i18n.t(subObjectKey) + ": " + i18n.t(item[subObjectKey]) + "\n";
            }
        }
    }

    return textToReturn;
}

/**
 * Create text line for an attribute
 */
const addLine = (values, key) => {
    return i18n.t(key) + ": " + i18n.t(values[key]) + "\n";
}

const formConverter = {
    convert: convert
};

export default formConverter;